/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReferralDocumentExport200ResponseData } from './GetReferralDocumentExport200ResponseData';
import {
    GetReferralDocumentExport200ResponseDataFromJSON,
    GetReferralDocumentExport200ResponseDataFromJSONTyped,
    GetReferralDocumentExport200ResponseDataToJSON,
    GetReferralDocumentExport200ResponseDataToJSONTyped,
} from './GetReferralDocumentExport200ResponseData';

/**
 * 
 * @export
 * @interface GetReferralDocumentExport200Response
 */
export interface GetReferralDocumentExport200Response {
    /**
     * 
     */
    data?: GetReferralDocumentExport200ResponseData;
}

/**
 * Check if a given object implements the GetReferralDocumentExport200Response interface.
 */
export function instanceOfGetReferralDocumentExport200Response(value: object): value is GetReferralDocumentExport200Response {
    return true;
}

export function GetReferralDocumentExport200ResponseFromJSON(json: any): GetReferralDocumentExport200Response {
    return GetReferralDocumentExport200ResponseFromJSONTyped(json, false);
}

export function GetReferralDocumentExport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReferralDocumentExport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GetReferralDocumentExport200ResponseDataFromJSON(json['data']),
    };
}

export function GetReferralDocumentExport200ResponseToJSON(json: any): GetReferralDocumentExport200Response {
    return GetReferralDocumentExport200ResponseToJSONTyped(json, false);
}

export function GetReferralDocumentExport200ResponseToJSONTyped(value?: GetReferralDocumentExport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetReferralDocumentExport200ResponseDataToJSON(value['data']),
    };
}

